var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-select',{attrs:{"search-nested":"","options":_vm.groupOptions,"placeholder":_vm.$t('common.select_parent'),"normalizer":_vm.normalizer},model:{value:(_vm.groupParent),callback:function ($$v) {_vm.groupParent=$$v},expression:"groupParent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }